import { render, staticRenderFns } from "./formDialog.vue?vue&type=template&id=3c2a288c&"
import script from "./formDialog.vue?vue&type=script&lang=js&"
export * from "./formDialog.vue?vue&type=script&lang=js&"
import style0 from "./formDialog.vue?vue&type=style&index=0&id=3c2a288c&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports